module.exports = __webpack_public_path__ + "static/media/whatWeOfferPartner.b4a90050.svg";